<template>
  <method-config-component
    :search-params="searchParams"
    :config-name-list="configNameList"
  />
</template>

<script>
import MethodConfigComponent from '../components/methodConfigComponent.vue'
export default {
  components: { MethodConfigComponent },
  data() {
    return {
      searchParams: {
        type: 2
      },
      configNameList: [
        'CASH_DEPOSIT',
        'OTHER',
        'CREDIT_DEPOSIT',
        'TRANSFER_DEPOSIT',
        'DEBT_PAYMENT',
        'PREPAID_CARD_PAYMENT'
      ]
    }
  }
}
</script>
